import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer style={{ padding: '12px 16px' }}>
      <div style={{ height: '1.5rem' }} />
      <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '12px 0 10px 0' }} />

      <div>
        <p style={{ fontSize: '0.85rem', color: '#757575', margin: 0 }}>
          All trademarks, logos and names are properties of their respective owners. All Rights Reserved. © Copyright 2025 MangaloreHub Services.
        </p>
        <div style={{ marginTop: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <Link to="/privacypolicy" style={{ color: '#1976d2', fontSize: '0.65rem', fontWeight: 500, textDecoration: 'none' }}>
            View our Privacy Policy
          </Link>
          <div style={{ fontSize: '0.60rem', color: '#757575', fontWeight: 500 }}>
            maintained by{' '}
            <a
              href="https://www.visionrsoft.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1976d2', textDecoration: 'none' , fontWeight: 300 , fontSize: '0.60rem' }}
            >
              VisionRsoft
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;